'use client';

// De canonieke knop woont in ui-kit/Button.js (portaalplan U1, EEN bron voor CRM
// en portaal). Dit pad blijft voor de bestaande imports.
export { default, BTN_T } from '@/ui-kit/Button.js';
